import styled, { css } from "styled-components";

import { animation } from "project-config/style";

import { getButtonStyle } from "./theme";

export const CommonButton = css<{ [key: string]: any }>`
  all: unset;
  cursor: pointer;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${(p) => p.height || "28px"};
  line-height: ${(p) => p.height || "28px"};
  min-width: ${(p) => p.width || "91px"};
  width: max-content;
  padding: 0 10px;
  color: var(--task-text-color);
  text-align: center;
  border: 1px solid transparent;
  font-size: ${(p) => (p.fontSize ? `${p.fontSize}` : "12px")};
  .loading-icon {
    ${animation("rotate")};
    margin: 0 0 0 5px;
  }
  ${(p) =>
    (p.$loading || p.disabled) &&
    css`
      cursor: not-allowed;
    `}
`;

export const PrimaryButton = styled.button<{ [key: string]: any }>`
  ${CommonButton};
  ${(p) => getButtonStyle(p).common};
  color: ${(p) => p.color || "#FFFFFF"};
  background: ${(p) => p.background || "var(--task-primary-button-bg)"};
  &:hover {
    background: ${(p) =>
      p.backgroundHover || "var(--task-primary-button-bg-hover)"};
  }
  ${(p) =>
    (p.disabled || p.$loading) &&
    css`
      background: ${(p) =>
        p.backgroundDisable || "var(--task-primary-button-bg-disable)"};
      &:hover {
        background: ${(p) =>
          p.backgroundDisable || "var(--task-primary-button-bg-disable)"};
      }
    `}
  border-radius: 4px;
  ${(p) => getButtonStyle(p).primary};
  ${(p) => (p.default || p.type === "default") && getButtonStyle(p).default};
`;
export const OutlineButton = styled.button<{ [key: string]: any }>`
  ${CommonButton};
  background: var(--task-btn-outline-bg);
  border: 1px solid ${(p) => p.color || "var(--task-text-color)"};
  color: ${(p) => p.color};
  border-radius: 4px;
  box-sizing: border-box;
  &:hover {
    background: var(--task-button-outline-hover);
  }
  ${(p) =>
    p.disabled &&
    css`
      background: transparent;
      border: 1px solid var(--task-button-outline-disable-border);
      color: var(--task-button-outline-disable);
      cursor: not-allowed;
    `}
`;
export const LinkButton = styled.button<{ [key: string]: any }>`
  ${CommonButton};
  min-width: max-content;
  padding: 0 6px;
  height: 24px;
  line-height: 24px;
  color: ${(p) => (p.color ? p.color : "")};
  &:hover {
    background: ${(p) => p.backgroundHover || p.theme["color-fill-3"]};
    border-radius: 4px;
  }
  &[disabled] {
    color: gray;
    background: unset;
  }
`;
